<template>
  <div v-loading.fullscreen.lock="loading" class="consult_detail">
    <div v-if="noData =='false'">
      <!-- 头部 -->
      <top-part :rightPart="true"></top-part>
      <div class="ctn_top consult_text">
        <div class="detail_top">
          <div class="consult_title">{{detailObj.newsTitle||''}}</div>
          <div class="consult_date">{{transfromMoment(detailObj.sendTime)}}</div>
          <div
            class="time_out"
            v-if="timerShow&&detailObj.newsIsPoint==1&&isPoint=='false'&&regStatus"
          >{{time}}s</div>
        </div>
        <div v-html="detailObj.newsRemarksAll" class="consult_ctn ql-editor"></div>
      </div>
    </div>
    <page-none v-if="noData =='true'" />
  </div>
</template>
<script type="text/ecmascript-6">
import Vue from "vue";
import topPart from "../../components/topPart";
import { toast } from "@/common/api/api.js";
import moment from "moment";
import pageNone from "../../components/pageNone";
export default {
  components: {
    topPart,
    pageNone
  },
  data() {
    return {
      loading: false,
      time: 0,
      timer: null,
      timerShow: true,
      detailObj: {}, //详情数据
      artivleReg: {}, //多长时间可得到多少积分
      isPoint: "",
      regStatus: null,
      noData: "" //页面接口返回错误标识
    };
  },
  mounted() {
    this.queryDetail();
  },
  destroyed() {
    clearInterval(this.timer);
  },
  methods: {
    // 积分是否打开
    getIntegralDataFn() {
      this.centralControl.axios.centralControl(
        "getIntegralData",
        res => {
          const { code, data, message } = res;
          if (code == 200) {
            this.artivleReg = data.article.reg
              ? JSON.parse(data.article.reg)
              : "";
            this.time = this.artivleReg.count;
            this.regStatus = data.article.regStatus;
            if (
              this.time > 0 &&
              this.isPoint == "false" &&
              this.detailObj.newsIsPoint == 1 &&
              this.regStatus
            )
              this.intervalFn();
          } else {
            this.$message.error(message);
          }
        },
        {}
      );
    },
    intervalFn() {
      this.timer = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          clearInterval(this.timer);
          this.timerShow = false;
          this.setStaffPointAPPFn();
          // return toast(this,`恭喜您获得${this.artivleReg.count}积分`,'success');
        }
      }, 1000);
    },
    // 时间转换
    transfromMoment(time) {
      if (time) {
        return moment(time).format("YYYY-MM-DD");
      }
      return "";
    },
    // 获取商品详情
    queryDetail() {
      const { consultDetailId } = this.$route.query;
      let params = {
        id: consultDetailId
      };
      this.centralControl.axios.centralControl(
        "getNewsDetail",
        res => {
          this.loading = false;
          const { code, message, data } = res;
          if (code == 200) {
            this.noData = 'false';
            this.detailObj = data;
            // isPoint：false未积分，true已积分
            this.isPoint = this.detailObj.isPoint;
            this.getIntegralDataFn();
          } else {
            this.noData = 'true';
            toast(this, message, "error");
          }
        },
        params
      );
    },
    // 生成积分
    setStaffPointAPPFn() {
      const { consultDetailId } = this.$route.query;
      let params = {
        id: consultDetailId
      };
      this.centralControl.axios.centralControl(
        "setStaffPointAPP",
        res => {
          this.loading = false;
          const { code, message, data } = res;
          if (code == 200) {
            toast(this, message, "success");
          } else {
            toast(this, message, "error");
          }
        },
        params
      );
    }
  }
};
</script>
<style lang="stylus" type="stylesheet/stylus">
@import '../../assets/stylus/common';
.consult_detail {
  background: #FFF;
  strong{
    font-weight:700 !important;
  }
  em{
    font-style: italic !important;
  }
  u{
    font-style: normal !important;
    text-decoration: underline !important;
  }
  h1{
    font-size: 2em !important;
    font-weight: normal !important;
  }
  h2{
     font-size: 1.5em !important;
    font-weight: normal !important;
  }

  ul li{
    list-style-position:inside !important;
    list-style-type: disc !important;
    list-style: normal !important;
  }
  ol li{
    list-style-position:inside !important;
    list-style: normal !important;
     list-style-type: decimal !important;
  }
  .ql-indent-2{
    margin-left:3em;
  }
  .ql-align-right{
    text-align: right !important;

  }
  .ql-align-center{
    text-align center !important;
  }

  .consult_text {
    padding: 16px;

    .consult_title {
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(53, 53, 53, 1);
      line-height: 25px;
    }

    .consult_date {
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(202, 202, 210, 1);
      line-height: 18px;
      margin: 10px 0 16px 0;
    }
  }

  .detail_top {
    position: relative;
  }

  .time_out {
    background-image: url('../../assets/images/back_time.png');
    background-size: 100% 100%;
    width: 50px;
    height: 50px;
    text-align: center;
    line-height: 44px;
    font-size: 14px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    position: absolute;
    right: 0px;
    bottom: 0px;
  }

  .consult_ctn {
    overflow: hidden;
    img {
      width: 50%;
      border-radius: 10px;
      margin-top: 4px;
      margin:0 auto;
      display:table-cell;
    }

    p, span, li {
      max-width: 100%;
      margin-top: 2px;
      font-size: 15px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: rgba(53, 53, 53, 1);
      line-height: 25px;
    }
  }
}
</style>